jQuery(($) => {
  class ImageTabList {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._list = this._element.find('.m-image-tab-list__list');
      this._tabs = this._element.find('.m-image-tab-list__tab');
      
      this._panelList = this._element.closest(".m-tab-panels");
      if (!this._panelList.length) {
        this._panelList = this._element.siblings().find(".m-tab-panels");
      }

      this._isAutomatic = this._list.data('automatic');
      this._autoplay    = this._list.data('autoplay');
      this._autoplayDelay = this._list.data('autoplay-interval');

      this._autoplayInterval = null;

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);

      this.startAutoplay();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._tabs.each((_, tab) => {
        $(tab).on('mousedown', (event) => {
          this.handleTabMousedown(event, tab);
        });

        $(tab).on('keydown', (event) => {
          this.handleTabKeydown(event, tab);
        });
      });

      // // If mouse enters the tabs or panels, pause autoplay
      this._element.on('mouseenter', () => {
        this.pauseAutoplay();
      });

      // If mouse leaves, resume autoplay
      this._element.on('mouseleave', () => {
        this.startAutoplay();
      });

      if (this._panelList && this._panelList.length) {
        this._panelList.on('mouseenter', () => {
          this.pauseAutoplay();
        });

        this._panelList.on('mouseleave', () => {
          this.startAutoplay();
        });

        this._panelList.on('mousedown keydown', () => {
          this.stopAutoplay();
        });
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Select
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabSelect = (tab, slow) => {
      if (slow) {
        this._panelList.addClass('m-tab-panels--slow');
      } else {
        this._panelList.removeClass('m-tab-panels--slow');
      }

      $(tab).image_tab('handleSelect');
      $(tab).closest('.m-image-tab-list__item').addClass('m-image-tab-list__item--selected');
      
      const $selected = this._element.find('.m-image-tab-list__item--selected');

      const offset = $selected[0].offsetLeft - this._element[0].offsetLeft - (this._element[0].clientWidth / 2) + ($selected[0].clientWidth / 2);

      this._element[0].scrollTo({ left: offset, behavior: 'smooth' });
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Deselect
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabDeselect = (tab) => {
      $(tab).image_tab('handleDeselect');
      $(tab).closest('.m-image-tab-list__item').removeClass('m-image-tab-list__item--selected');
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabMousedown = (event, tab) => {
      event.preventDefault();

      this.stopAutoplay();
      this.handleTabSelect(tab);

      this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Tab Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTabKeydown = (event, tab) => {
      switch (event.key) {
        case 'Enter':
        case 'spacebar':
        case ' ':
          if (!this._isAutomatic) {
            event.preventDefault();
            this.stopAutoplay();

            this.handleTabSelect(tab);

            this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
          }
          break;

        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          this.stopAutoplay();

          const $prevItem = $(tab).closest('.m-image-tab-list__item').prev();

          if ($prevItem[0]) {
            const $prevTab = $prevItem.find('.m-image-tab-list__tab');

            $prevTab.focus();

            if (this._isAutomatic) {
              this.handleTabSelect($prevTab);
              this._tabs.not($prevTab).each((_, _tab) => this.handleTabDeselect(_tab));
            }
          }
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          this.stopAutoplay();

          const $nextItem = $(tab).closest('.m-image-tab-list__item').next();

          if ($nextItem[0]) {
            const $nextTab = $nextItem.find('.m-image-tab-list__tab');

            $nextTab.focus();

            if (this._isAutomatic) {
              this.handleTabSelect($nextTab);
              this._tabs.not($nextTab).each((_, _tab) => this.handleTabDeselect(_tab));
            }
          }
          break;

        case 'Home':
          event.preventDefault();
          this.stopAutoplay();

          const $firstTab = this._list.find('.m-image-tab-list__item').first().find('.m-image-tab-list__tab');

          $firstTab.focus();

          if (this._isAutomatic) {
            this.handleTabSelect($firstTab);
            this._tabs.not($firstTab).each((_, _tab) => this.handleTabDeselect(_tab));
          }
          break;

        case 'End':
          event.preventDefault();
          this.stopAutoplay();

          const $lastTab = this._list.find('.m-image-tab-list__item').last().find('.m-image-tab-list__tab');

          $lastTab.focus();

          if (this._isAutomatic) {
            this.handleTabSelect($lastTab);
            this._tabs.not($lastTab).each((_, _tab) => this.handleTabDeselect(_tab));
          }
          break;
      }
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Autoplay
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    startAutoplay() {
      if (this._autoplay) {
        clearInterval(this._autoplayInterval);
        this._autoplayInterval = setInterval(() => {
          
          const $selectedTab = this._element.find('.m-image-tab-list__item--selected');
          const $nextItem = $($selectedTab).closest('.m-image-tab-list__item').next();

          let $nextTab = null;
          if ($nextItem[0]) {
            $nextTab = $nextItem.find('.m-image-tab-list__tab');
          } else {
            $nextTab = this._list.find('.m-image-tab-list__item').first().find('.m-image-tab-list__tab');
          }

          if ($nextTab) {
            this.handleTabSelect($nextTab, true);
            this._tabs.not($nextTab).each((_, _tab) => this.handleTabDeselect(_tab));
          }

        }, this._autoplayDelay);
      }
    }
    
    pauseAutoplay() {
      clearInterval(this._autoplayInterval);
    }

    stopAutoplay() {
      clearInterval(this._autoplayInterval);
      if (this._autoplay) {
        this._autoplay = false;
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.image_tab_list = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].tab_list = new ImageTabList(_[i], opt);
      else ret = _[i].tab_list[opt].apply(_[i].tab_list, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-image-tab-list').image_tab_list();
});
